'use strict'

$(function () {
	// Read CSRF token when page is loaded and set in the header for all AJAX requests
	$.ajaxSetup({
		beforeSend: function (xhr) {
			xhr.setRequestHeader('X-CSRF-TOKEN', document.head.querySelector('meta[name="csrf-token"]').content)
		}
	})
})
